import { SelectionAdorner } from './SelectionAdorner/SelectionAdorner';
import { IRect, getBoundRect } from 'utils/GeometryUtils';

interface IMultiSelectionAdornerProps {
  margin?: number;
  innerRecs: IRect[];
  showMutualRect: boolean;
}

/**
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function MultiSelectionAdorner({ innerRecs, margin = 0, showMutualRect }: IMultiSelectionAdornerProps) {
  const rect = getBoundRect(innerRecs);

  if (rect == null) {
    return null;
  }

  return (
    <>
      {showMutualRect && <SelectionAdorner margin={margin} {...rect} />}
      {innerRecs.map((rectItem, index) => (
        <SelectionAdorner key={index} margin={margin} {...rectItem} />
      ))}
    </>
  );
}
